'use strict';

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var SpanContext = require('opentracing').SpanContext;

var DatadogSpanContext =
/*#__PURE__*/
function (_SpanContext) {
  _inherits(DatadogSpanContext, _SpanContext);

  function DatadogSpanContext(props) {
    var _this;

    _classCallCheck(this, DatadogSpanContext);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatadogSpanContext).call(this));
    props = props || {};
    _this._traceId = props.traceId;
    _this._spanId = props.spanId;
    _this._parentId = props.parentId || null;
    _this._name = props.name;
    _this._isFinished = props.isFinished || false;
    _this._tags = props.tags || {};
    _this._sampling = props.sampling || {};
    _this._baggageItems = props.baggageItems || {};
    _this._traceFlags = props.traceFlags || {};
    _this._traceFlags.sampled = _this._traceFlags.sampled !== false;
    _this._traceFlags.debug = _this._traceFlags.debug === true;
    _this._noop = props.noop || null;
    _this._trace = props.trace || {
      started: [],
      finished: []
    };
    return _this;
  }

  _createClass(DatadogSpanContext, [{
    key: "toTraceId",
    value: function toTraceId() {
      return this._traceId.toString(10);
    }
  }, {
    key: "toSpanId",
    value: function toSpanId() {
      return this._spanId.toString(10);
    }
  }]);

  return DatadogSpanContext;
}(SpanContext);

module.exports = DatadogSpanContext;